import { jsxs as N, jsx as w, Fragment as n } from "react/jsx-runtime";
import { u as l } from "../../chunks/use-sitecore-context.C7g4vcbm.js";
import { L as S } from "../../chunks/logo.IIdCMlDN.js";
import { RichText as i } from "@sitecore-jss/sitecore-jss-nextjs";
import { s as a, a as y, B as z, S as x, M as r } from "../../chunks/Subscription.CgP0M3T8.js";
import { D as E } from "../../chunks/divider.C0gR8ZZB.js";
import { c } from "../../chunks/clsx.OuTLNxxd.js";
const o = "data:image/svg+xml;base64,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", C = {
  site: {
    footer: {
      newsletterPlaceholderText: { value: "Enter your email address" },
      newsletterTitle: { value: "Sign Up for Our Newsletter" },
      formstackId: { value: "SOME-SITECORE-ID" },
      emailAddressFieldName: { value: "email" },
      enterpriseMarketingFieldName: { value: "email" },
      newsletterActionUrl: {
        value: {
          href: "#",
          text: "Optional CTA",
          anchor: "",
          linktype: "internal",
          class: ""
        }
      },
      copyright: {
        value: "Copyright 1999-2023 C-HCA, Inc.; All rights reserved"
      },
      footerLinks: {
        value: [
          {
            value: {
              anchor: "",
              href: "https://hcahealthcare.com/legal/index.dot#terms",
              linktype: "external",
              target: "",
              text: "Terms of Use",
              url: "https://hcahealthcare.com/legal/index.dot#terms"
            }
          },
          {
            value: {
              anchor: "",
              href: "https://hcahealthcare.com/legal/index.dot#terms1",
              linktype: "external",
              target: "",
              text: "Notice at Collection",
              url: "https://hcahealthcare.com/legal/index.dot#terms1"
            }
          },
          {
            value: {
              anchor: "",
              href: "https://hcahealthcare.com/legal/index.dot#terms2",
              linktype: "external",
              target: "",
              text: "Privacy Policy",
              url: "https://hcahealthcare.com/legal/index.dot#terms2"
            }
          },
          {
            value: {
              anchor: "",
              href: "https://hcahealthcare.com/legal/index.dot#terms3",
              linktype: "external",
              target: "",
              text: "Do Not Sell My Personal Information",
              url: "https://hcahealthcare.com/legal/index.dot#terms3"
            }
          }
        ]
      },
      corporateLinks: {
        value: `
          <p>
          <strong>For patients&nbsp;&nbsp;</strong>
          <a href="http://google.com">Pricing and financial information</a>&nbsp; |&nbsp;&nbsp;
          <a href="http://google.com">MyHealthOne</a></p>
          <p><strong>Additional resources&nbsp;&nbsp;</strong>
          <a href="http://google.com">For physicians</a>&nbsp; |&nbsp;&nbsp;
          <a href="http://google.com">For nurses</a>&nbsp; |&nbsp;&nbsp;
          <a href="http://google.com">For investors</a>
          </p>
          <hr />
          <p>
          <strong>Our organization&nbsp;&nbsp;</strong>
          <a href="https://www.google.com">About HCA Healthcare</a>&nbsp; |&nbsp;&nbsp;
          <a href="https://www.google.com">Government Relations</a>&nbsp; |&nbsp;&nbsp;
          <a href="https://www.google.com">Press kit</a>&nbsp; |&nbsp;&nbsp;
          <a href="https://www.google.com">Careers</a>&nbsp; |&nbsp;&nbsp;
          <a href="https://www.google.com">Contact us</a>&nbsp; |&nbsp;&nbsp;
          <a href="https://www.google.com">We Show Up</a>
          </p>
          <hr />
          <p>
          <strong>Publications&nbsp;&nbsp;</strong>
          <a href="https://www.google.com">HCA Healthcare Today</a>&nbsp; |&nbsp;&nbsp;
          <a href="https://www.google.com">HCA Healthcare Magazine</a>&nbsp; |&nbsp;&nbsp;
          <a href="https://www.google.com">Impact Report</a>
          </p>
        `
      },
      disclaimer: {
        value: `<p>The terms "HCA" or the "Company" as used in this website refer to HCA Healthcare, Inc. and its 
        affiliates, unless otherwise stated or indicated by context. The term "facilities" refers to entities 
        owned or operated by subsidiaries or affiliates of HCA Healthcare, Inc. References herein to 
        "HCA employees" or to "our employees" refer to employees of affiliates of HCA Healthcare, Inc.</p>`
      },
      complianceLinks: {
        value: [
          {
            value: {
              anchor: "",
              href: "https://hcahealthcare.com/legal/index.dot#terms4",
              linktype: "external",
              target: "_blank",
              text: "Legal Requirements",
              url: "https://hcahealthcare.com/legal/index.dot#terms4"
            }
          },
          {
            value: {
              anchor: "",
              href: "https://hcahealthcare.com/legal/index.dot#terms5",
              linktype: "external",
              target: "_blank",
              text: "Notice at Collection",
              url: "https://hcahealthcare.com/legal/index.dot#terms5"
            }
          },
          {
            value: {
              anchor: "",
              href: "https://hcahealthcare.com/legal/index.dot#terms6",
              linktype: "external",
              target: "_blank",
              text: "Terms of Use",
              url: "https://hcahealthcare.com/legal/index.dot#terms6"
            }
          },
          {
            value: {
              anchor: "",
              href: "https://hcahealthcare.com/legal/index.dot#terms7",
              linktype: "external",
              target: "_blank",
              text: "Privacy Policy",
              url: "https://hcahealthcare.com/legal/index.dot#terms7"
            }
          }
        ]
      },
      socialTitle: {
        value: "Follow us"
      },
      socialLinkList: {
        fields: {
          iconLinks: [
            {
              fields: {
                id: "{c3452a49-9265-4250-9322-90999f7e7781}",
                icon: {
                  fields: {
                    iconName: {
                      value: "facebook"
                    }
                  }
                },
                link: {
                  value: {
                    anchor: "",
                    href: "https://www.facebook.com",
                    linktype: "external",
                    target: "_blank",
                    text: "facebook",
                    url: "https://www.facebook.com"
                  }
                }
              }
            },
            {
              fields: {
                id: "{c3452a49-9265-4250-9322-90999f7e7782}",
                icon: {
                  fields: {
                    iconName: {
                      value: "insta"
                    }
                  }
                },
                link: {
                  value: {
                    anchor: "",
                    href: "https://www.instagram.com",
                    linktype: "external",
                    target: "_blank",
                    text: "instagram",
                    url: "https://www.instagram.com"
                  }
                }
              }
            },
            {
              fields: {
                id: "{c3452a49-9265-4250-9322-90999f7e7783}",
                icon: {
                  fields: {
                    iconName: {
                      value: "twitter"
                    }
                  }
                },
                link: {
                  value: {
                    anchor: "",
                    href: "https://www.twitter.com",
                    linktype: "external",
                    target: "_blank",
                    text: "twitter",
                    url: "https://www.twitter.com"
                  }
                }
              }
            }
          ]
        }
      }
    },
    identity: {
      address: {
        value: "<p><strong>HCA Healthcare Florida</strong><br />450 E Las Olas Blvd<br />Fort Lauderdale, FL 33301</p>"
      },
      mainLogo: {
        value: {
          alt: "hca logo",
          height: "100",
          src: o,
          width: "200"
        }
      },
      siteName: { value: "HCA Florida" }
    }
  },
  location: {
    footer: {
      newsletterPlaceholderText: { value: "Enter your email address" },
      newsletterTitle: { value: "Sign Up for Our Newsletter" },
      formstackId: { value: "SOME-SITECORE-ID" },
      emailAddressFieldName: { value: "email" },
      enterpriseMarketingFieldName: { value: "email" },
      newsletterActionUrl: {
        value: {
          href: "#",
          text: "Optional CTA",
          anchor: "",
          linktype: "internal",
          class: ""
        }
      },
      copyright: {
        value: "Copyright 1999-2023 C-HCA, Inc.; All rights reserved"
      },
      footerLinks: {
        value: [
          {
            value: {
              anchor: "",
              href: "https://hcahealthcare.com/legal/index.dot#terms",
              linktype: "external",
              target: "",
              text: "Terms of Use",
              url: "https://hcahealthcare.com/legal/index.dot#terms"
            }
          },
          {
            value: {
              anchor: "",
              href: "https://hcahealthcare.com/legal/index.dot#terms1",
              linktype: "external",
              target: "",
              text: "Notice at Collection",
              url: "https://hcahealthcare.com/legal/index.dot#terms1"
            }
          }
        ]
      },
      complianceLinks: {
        value: [
          {
            value: {
              anchor: "",
              href: "https://hcahealthcare.com/legal/index.dot#terms4",
              linktype: "external",
              target: "",
              text: "Terms of Use",
              url: "https://hcahealthcare.com/legal/index.dot#terms4"
            }
          },
          {
            value: {
              anchor: "",
              href: "https://hcahealthcare.com/legal/index.dot#terms5",
              linktype: "external",
              target: "",
              text: "Notice at Collection",
              url: "https://hcahealthcare.com/legal/index.dot#terms5"
            }
          }
        ]
      },
      socialTitle: {
        value: "Follow us"
      },
      socialLinkList: {
        fields: {
          iconLinks: [
            {
              fields: {
                id: "{c3452a49-9265-4250-9322-90999f7e7784}",
                icon: {
                  fields: {
                    iconName: {
                      value: "facebook"
                    }
                  }
                },
                link: {
                  value: {
                    anchor: "",
                    href: "https://www.facebook.com",
                    linktype: "external",
                    target: "_blank",
                    text: "facebook",
                    url: "https://www.facebook.com"
                  }
                }
              }
            }
          ]
        }
      }
    },
    identity: {
      address: {
        value: "<p>450 E Las Olas Blvd<br />Fort Lauderdale, FL 33301</p>"
      },
      mainLogo: {
        value: {
          alt: "hca logo",
          height: "100",
          src: o,
          width: "200"
        }
      },
      siteName: { value: "HCA Florida" }
    }
  }
};
({
  ...C.site.footer
}, { ...C.site.identity });
const h = ({ data: L }) => {
  var e;
  const { footer: M } = L, { corporateLinks: s, copyright: j } = M, { sitecoreContext: D } = l(), t = (e = D.theme) == null ? void 0 : e.smallLogo;
  return /* @__PURE__ */ N("div", { className: `${a.containerFlex} neu-bg-main-100 neu-text-plain-0`, children: [
    /* @__PURE__ */ w("div", { className: "row justify-md-content-start", children: /* @__PURE__ */ w(i, { tag: "div", field: s, className: a.richText }) }),
    /* @__PURE__ */ N("div", { className: "row mt-4 my-md-4", children: [
      /* @__PURE__ */ w("div", { className: "col-md-6 col-12", children: t && /* @__PURE__ */ w(S, { field: t, logoClassName: "w-50" }) }),
      /* @__PURE__ */ w("div", { className: "col-md-6 col-12 my-5 my-md-0", children: /* @__PURE__ */ w(
        y,
        {
          socialTitle: M == null ? void 0 : M.socialTitle,
          socialLinkList: M == null ? void 0 : M.socialLinkList,
          socialBlockClass: "align-items-start align-items-md-end",
          tag: "p"
        }
      ) })
    ] }),
    /* @__PURE__ */ w(z, { copyright: j, fields: M }),
    /* @__PURE__ */ w(i, { tag: "div", field: M == null ? void 0 : M.disclaimer, className: "mt-5" })
  ] });
}, T = ({ fields: L }) => {
  var t;
  const M = !((t = L == null ? void 0 : L.formstackId) != null && t.value), s = (L == null ? void 0 : L.callToAction) && (L == null ? void 0 : L.callToAction.value.href) !== "", j = c("d-flex flex-column flex-lg-row", {
    "justify-content-center": !s
  }), D = c("col-12 mt-5 mt-lg-0 position-relative", {
    "col-lg-6": !M
  });
  return /* @__PURE__ */ N("div", { className: c(j, "neu-bg-support-60 neu-text-plain-0 p-5"), children: [
    /* @__PURE__ */ w("div", { className: M ? "d-none" : "col-12 col-lg-6", children: /* @__PURE__ */ w(x, { ...L }) }),
    /* @__PURE__ */ w("div", { className: D, children: /* @__PURE__ */ w(y, { socialTitle: L == null ? void 0 : L.socialTitle, socialLinkList: L == null ? void 0 : L.socialLinkList }) })
  ] });
}, A = ({
  fields: L,
  data: M
}) => {
  var s;
  return /* @__PURE__ */ N(n, { children: [
    /* @__PURE__ */ w(T, { fields: M == null ? void 0 : M.footer }),
    /* @__PURE__ */ w(r, { fields: L }),
    /* @__PURE__ */ w(E, { type: "horizontal", size: "2x" }),
    /* @__PURE__ */ w(z, { copyright: (s = M == null ? void 0 : M.footer) == null ? void 0 : s.copyright, fields: M == null ? void 0 : M.footer })
  ] });
}, k = ({ fields: L, rendering: M, params: s }) => {
  const {
    sitecoreContext: {
      siteAttributes: { isMarket: j, isCorporate: D }
    }
  } = l(), { site: t, location: e } = L, u = j ? t : e;
  return u ? /* @__PURE__ */ w("div", { "data-test-id": M == null ? void 0 : M.componentName, children: D ? /* @__PURE__ */ w(h, { data: u }) : /* @__PURE__ */ w(A, { fields: L, data: u, rendering: M, params: s }) }) : null;
};
export {
  z as BottomBlock,
  k as Footer,
  r as MiddleBlock,
  y as SocialIcons,
  A as StandardFooter,
  x as Subscription,
  T as TopBlock,
  C as footerMock
};
